// extracted by mini-css-extract-plugin
export default {"toursWrapper":"styles_toursWrapper__dvBPa","tourCardsWrapper":"styles_tourCardsWrapper__z4ia4","tourCards":"styles_tourCards__4wH1d"};